import { select } from "d3";
import { textactive2 } from "@/_core/_helpers/_parametric_tools";

/**
 * Create x, y and last tooltip
 * @param {object} _this: context variables
 * @param {object} svg: svg node for chart
 * @param {string} svgName: svg NAME for chart
 * @param {function} currencyFormat: format function for y-axis
 * @param {double} valueLast: latest y value to fix
 * @param {integer} xTooltipWidth: x tooltip width in px
 * @param {integer} yTooltipWidth: y tooltip width in px
 * @param {boolean} colorTheme: dark = true, light = false
 * @param {color} colorLast: background color of fixed last value div
 * @param {color} colorY: background color of hovered y value
 * @param {color} colorX: background color of hovered date
 * @param {boolean} isLeft: chart is left = true/null or right=false
 */
export function createXYLastTooltips(
  _this,
  svg,
  svgName,
  currencyFormat,
  valueLast,
  xTooltipWidth,
  yTooltipWidth,
  colorTheme,
  colorLast,
  colorY,
  colorX,
  isLeft
) {
  let sharp = "#";
  select(`${sharp}${svg.parentElement}`)
    .selectAll(".tooltip")
    .remove();
  let position = isLeft ? "right" : "left";
  let positionPx = isLeft
    ? svg.width + svg.margin.right + 2 + "px"
    : svg.width + svg.margin.left + 2 + "px";
  _this.chartElements[svgName]["lastYTooltip"] = select(
    `${sharp}${svg.parentElement}`
  )
    .append("div")
    .style("opacity", 1)
    .style("margin", "0 auto")
    .style("text-align", "center")
    .style("background", colorLast)
    .style("border", colorLast)
    .style("color", textactive2(colorTheme))
    .style("padding", "2px")
    .attr("class", "tooltip")
    .style("font-size", "0.8rem")
    .style("width", yTooltipWidth + "px")
    .style(position, positionPx)
    .style("top", svg.y(valueLast) + svg.margin.top - 9 + "px")
    .html(currencyFormat(valueLast));
  _this.chartElements[svgName]["yTooltip"] = select(
    `${sharp}${svg.parentElement}`
  )
    .append("div")
    .style("opacity", 0)
    .style("margin", "0 auto")
    .style("text-align", "center")
    .style("background", colorY)
    .style("border", colorY)
    .style("color", textactive2(colorTheme))
    .style("padding", "2px")
    .attr("class", "tooltip")
    .style("font-size", "0.8rem")
    .style("width", yTooltipWidth + "px")
    .html("");
  _this.chartElements[svgName]["xTooltip"] = select(
    `${sharp}${svg.parentElement}`
  )
    .append("div")
    .style("opacity", 0)
    .style("margin", "0 auto")
    .style("text-align", "center")
    .style("background", colorX)
    .style("border", colorX)
    .style("color", textactive2(colorTheme))
    .style("padding", "2px")
    .attr("class", "tooltip")
    .style("top", svg.height + svg.margin.top + 5 + "px")
    .style("font-size", "0.8rem")
    .style("width", xTooltipWidth + "px")
    .html("");
  return _this.chartElements[svgName];
}
